import {Link, Text} from '@primer/react'

export const ModelLegalTerms = () => {
  const productTermsLink = 'https://www.microsoft.com/licensing/terms/productoffering/MicrosoftAzure/MCA'
  const privacyStatementLink = 'https://www.microsoft.com/licensing/terms/product/PrivacyandSecurityTerms/MCA'

  return (
    <Text sx={{color: 'fg.muted', fontSize: 0}}>
      Azure hosted. AI powered, can make mistakes.{' '}
      <Link href="mailto:aismodelssupport@microsoft.com" inline muted>
        Report
      </Link>{' '}
      harmful content. Subject to{' '}
      <Link href={productTermsLink} inline muted>
        Product Terms
      </Link>{' '}
      &{' '}
      <Link href={privacyStatementLink} inline muted>
        Privacy Statement
      </Link>
      . Not intended for production/sensitive data.
    </Text>
  )
}

try{ ModelLegalTerms.displayName ||= 'ModelLegalTerms' } catch {}